// Times are shown in the employee's office timezone (not the viewer's browser),
// so everyone reads the same clock time. Offices without a timezone use Manila.
export const DEFAULT_TZ = "Asia/Manila";

const validTz = (tz) => {
  try {
    new Intl.DateTimeFormat("en-GB", { timeZone: tz });
    return true;
  } catch (e) {
    return false;
  }
};

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const parts = (v, tz) => {
  const zone = tz && validTz(tz) ? tz : DEFAULT_TZ;
  const o = {};
  new Intl.DateTimeFormat("en-GB", { timeZone: zone, hourCycle: "h23", day: "2-digit", month: "numeric", hour: "2-digit", minute: "2-digit" })
    .formatToParts(new Date(v))
    .forEach((p) => { o[p.type] = p.value; });
  return o;
};

export const formatTimeInTz = (v, tz) => {
  if (!v) return "-";
  const p = parts(v, tz);
  return `${p.hour}:${p.minute}`;
};

export const formatDateTimeInTz = (v, tz) => {
  if (!v) return "-";
  const p = parts(v, tz);
  return `${p.day} ${MONTHS[Number(p.month) - 1]}, ${p.hour}:${p.minute}`;
};

export const tzLabel = (tz) => (tz && validTz(tz) ? tz : DEFAULT_TZ).replace(/_/g, " ");

// "DD Mon YYYY, HH:mm:ss" in a timezone (activity timeline).
export const formatFullInTz = (v, tz) => {
  if (!v) return "-";
  const zone = tz && validTz(tz) ? tz : DEFAULT_TZ;
  const o = {};
  new Intl.DateTimeFormat("en-GB", { timeZone: zone, hourCycle: "h23", day: "2-digit", month: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit" })
    .formatToParts(new Date(v))
    .forEach((p) => { o[p.type] = p.value; });
  return `${o.day} ${MONTHS[Number(o.month) - 1]} ${o.year}, ${o.hour}:${o.minute}:${o.second}`;
};

// Options for a timezone picker: "Asia/Manila (UTC+8)", sorted by name.
export const timeZoneOptions = () => {
  const names = typeof Intl.supportedValuesOf === "function" ? Intl.supportedValuesOf("timeZone") : ["Asia/Manila", "Asia/Kolkata", "Asia/Singapore", "Asia/Dubai", "Europe/London", "America/New_York", "America/Los_Angeles", "Australia/Sydney", "UTC"];
  return names.map((n) => {
    let off = "";
    try {
      off = new Intl.DateTimeFormat("en-GB", { timeZone: n, timeZoneName: "shortOffset" }).formatToParts(new Date()).find((p) => p.type === "timeZoneName")?.value || "";
    } catch (e) { /* label without offset */ }
    return { value: n, label: off ? `${n} (${off.replace("GMT", "UTC")})` : n };
  });
};
